namespace RedBullMOBILE360.Sms {
    export class SubscriptionCodesColumns {
        static columnsKey = 'Sms.SubscriptionCodes';
    }
}